import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../button/button.module';
import { IconicModule } from '../iconic/iconic.module';
import { TreeListModule } from '../tree-list/tree-list.module';
import { SideMenuComponent } from './side-menu.component';

@NgModule({
  imports: [CommonModule, ButtonModule, IconicModule, TreeListModule],
  declarations: [SideMenuComponent],
  exports: [SideMenuComponent],
})
export class SideMenuModule {}
